import React from 'react';
import { useReveal } from '../lib/useReveal';
const HERO_MOCKUP = 'https://cdn.magicpatterns.com/uploads/uaZdCuVEFzhNFpXgAbYiip/ChatGPT_Image_26_may_2026,_15_25_57.png';
const PILLS = ['100% Digital', 'Acceso Inmediato', 'Desde Cero', 'A Tu Ritmo', 'Ideal para Emprender', 'Recetas Premium'];
export function HeroSection() {
  const [ref, isVisible] = useReveal();
  return <section className="relative pt-6 pb-8 md:pt-10 md:pb-10 px-4 overflow-hidden bg-gradient-to-b from-[#fdf2f4] to-[#fff8f9]" data-id="element-145">
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10 pointer-events-none" data-id="element-146">
        <div className="absolute -top-[20%] -right-[10%] w-[60%] h-[60%] rounded-full bg-[#fce7e9] blur-[120px] opacity-70" data-id="element-147"></div>
        <div className="absolute top-[40%] -left-[10%] w-[50%] h-[50%] rounded-full bg-[#f8d7da] blur-[120px] opacity-50" data-id="element-148"></div>
      </div>

      <div ref={ref} className={`reveal max-w-3xl mx-auto flex flex-col items-center text-center ${isVisible ? 'is-visible' : ''}`} data-id="element-149">
        <span className="inline-block py-1 px-3 rounded-full bg-white/70 border border-[#e89aaa]/30 text-[#8b6f47] text-[10px] font-semibold tracking-widest uppercase mb-3 shadow-sm" data-id="element-150">
          ♡ Pastelería Premium ♡
        </span>

        <h1 className="text-2xl sm:text-3xl md:text-5xl font-serif font-bold text-[#6b4f3a] leading-[1.05] mb-3" data-id="element-151">
          Aprendé Pastelería{' '}
          <span className="italic text-[#e89aaa]" data-id="element-152">y empezá a vender</span> desde
          casa.
        </h1>

        <div className="w-full max-w-[280px] sm:max-w-xs md:max-w-sm my-2" data-id="element-153">
          <img src={HERO_MOCKUP} alt="MegaPack Pastelería Premium" className="w-full h-auto animate-float" data-id="element-154" />
        </div>

        <p className="text-sm md:text-base text-[#8b6f47] max-w-md leading-snug" data-id="element-155">
          El MegaPack premium con{' '}
          <span className="font-serif italic text-[#e89aaa] font-semibold" data-id="element-156">
            6 Tomos + 6 Bonos
          </span>{' '}
          para aprender pastelería moderna y emprender desde casa.
        </p>

        <div className="flex flex-wrap justify-center gap-1.5 mt-3 mb-3 max-w-xl" data-id="element-157">
          {PILLS.map((pill, i) => <span key={i} className="flex items-center gap-1 text-[10px] md:text-xs text-[#8b6f47] bg-white border border-[#f4b6c2]/40 rounded-full px-2.5 py-1 shadow-sm" data-id="element-158">
              <span className="text-[#e89aaa]" data-id="element-159">✓</span> {pill}
            </span>)}
        </div>

        <div className="flex flex-col items-center gap-2 mt-2" data-id="element-160">
          <a href="#cta" className="cta-btn inline-block px-8 py-3.5 rounded-full bg-[#e89aaa] hover:bg-[#d98ba0] text-white font-medium text-sm md:text-base tracking-wider text-center shadow-[0_8px_20px_rgba(232,154,170,0.35)] hover:shadow-[0_12px_25px_rgba(232,154,170,0.45)]" data-id="element-161">
            QUIERO ACCEDER AL MEGAPACK ♡
          </a>
          <p className="text-[10px] text-[#8b6f47]/70 tracking-wider uppercase" data-id="element-162">
            🔒 Pago seguro · ⚡ Acceso inmediato
          </p>
          <span className="inline-flex items-center gap-1.5 text-[11px] font-semibold text-[#009ee3] bg-[#009ee3]/10 border border-[#009ee3]/20 rounded-full px-3 py-1" data-id="element-163">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" data-id="element-164">
              <path d="M12 2C6.48 2 2 6.03 2 11c0 2.83 1.46 5.35 3.75 7l-.6 3.5 3.3-1.83c1.07.3 2.2.46 3.55.46 5.52 0 10-4.03 10-9S17.52 2 12 2z" data-id="element-165" />
            </svg>
            Compra segura con Mercado Pago
          </span>
        </div>
      </div>
    </section>;
}